export default{
    state:{
        guests: {
            items: []
        }
    },
    mutations:{
        set_guests(state, guests){
            state.guests = guests
        },
        insert_guest(state, guest){
            state.guests.items = [guest, ...state.guests.items]
        },
        update_guest(state, guest){
            state.guests.items = state.guests.items.map(item => item.id == guest.id ? guest : item)
        },
    },
    actions:{
        async getGuest({dispatch, commit}, options){
            let guests = await dispatch('apiQuery', {method: '/guest/all', body: options})
            await commit('set_guests', guests)
        },

       async createGuest({dispatch, commit}, guest){
            await commit('insert_guest', await dispatch('apiQuery', {method: `/guest/create`, body: guest}))
        },

        async getGuestById({dispatch}, id) {
            return await dispatch('apiQuery', {method: `/guest/${id}`})
        },

        async deleteGuestById({dispatch}, guest_id){
            await dispatch('apiQuery', {method: `/guest/remove`, body: {id: guest_id}})
        },

        async updateGuest({dispatch, commit}, guest){
            commit('update_guest',await dispatch('apiQuery', {method: `/guest/update`, body: guest}))
        },

        async blockGuest({dispatch, commit}, guest){
            commit('update_guest', await dispatch('apiQuery', {method: '/guest/block', body: guest}))
        },

        async checkPhone({dispatch}, phone){
            return await dispatch('apiQuery', {method: `/guest/check_phone`, body: phone})
        },

        async getGuestHistory({dispatch}, options){
            return await dispatch('apiQuery', {method: '/guest/history', body: options})
        }

    },
    getters:{
        guests(state){
            return state.guests
        },
        guest_by_id(state){
            return (id) => { 
                return state.guests.items?.find(item => item.id == id) 
            }
        },
        options(state){
            return state.options
        }
    }
}